var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isLog)?_c('core-filter'):_vm._e(),_c('core-view'),(_vm.isLog)?_c('core-drawer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }